import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const FilterStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      height: "100%",
      marginBottom: "10px",
    },
    button: {
      background: theme.palette.primary.main,
      color: "#E0E0E0",
      justifyContent: "space-between",
      textTransform: "none",
      height: "33px",
      "&:hover": {
        backgroundColor: "#E0E0E0",
        boxShadow: "0px 50px -1px #787878",
        color: "#787878",
        border: "none",
      },
    },
    searchbar: {
      width: "100%",
      paddingLeft: "10px",
      [theme.breakpoints.up("lg")]: {
        width: "calc(50vw - 95%)",
        maxWidth: "380px",
        paddingRight: "10px",
        textAlign: "end",
      },
      [`& fieldset`]: {
        borderRadius: 20,
        border: `none`,
        background: "#BDC2C550",
      },
      "& .MuiOutlinedInput-input": {
        padding: 6,
        fontWeight: "bold",
      },
    },
    searchList: {
      maxHeight: "400px",
      overflowY: "auto",
      marginTop: "10px",
      borderRadius: "6px",
      height: "auto",
      border: "1px solid #e7e7e7",
      backgroundColor: theme.palette.background.paper,
      position: "fixed",
      zIndex: "9999",
      width: "auto",
      padding: "20px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "90%",
      },
    },
    adornedStart: {
      marginRight: "32px",
    },
    searchbarIcon: {
      marginRight: "12px",
    },
    error: {
      color: "red",
      padding: "0px 10px",
    },
    searchSubtitle: {
      padding: "10px",
      fontSize: "20px",
    },
    listContainer: {
      width: "100%",
      padding: "10px",
    },
    listItem: {
      width: "100%",
      padding: "10px 0px",
      cursor: "pointer",
    },
    listItemRank: {
      maxWidth: "fit-content",
      marginRight: "15px",
    },
    listItemIcon: {
      minWidth: "fit-content",
      marginRight: "10px",
      maxHeight: "30px",
    },
    listName: {
      fontSize: "14px",
    },
  }),
);
